import {
  mdiTextBoxEditOutline,
  mdiCardMultipleOutline,
  mdiAlphabeticalVariant,
  mdiCheckboxMarkedCircleMinusOutline,
  mdiBook,
  mdiWeightLifter,
  mdiButtonPointer,
  mdiLockQuestion,
  mdiPuzzleEditOutline,
  mdiTextSearch,
  mdiNumeric2BoxMultipleOutline,
  mdiBookAlphabet,
  mdiFormatListGroupPlus,
  mdiFileArrowUpDownOutline,
  mdiFilterOutline,
} from '@quasar/extras/mdi-v7';
import type { StepCategory, StepTypeKebabCase } from 'src/types/course/step';

export const useIcon = () => {
  function stepCategoryIcon(stepCategory?: StepCategory) {
    switch (stepCategory) {
      case 'Practice':
        return mdiWeightLifter;
      case 'Test':
        return mdiWeightLifter;
      case 'Exam':
        return mdiTextSearch;
      case 'Assessment':
        return mdiWeightLifter;
      case 'Filter':
        return mdiWeightLifter;
      case 'Theory':
        return mdiBook;
      default:
        return mdiLockQuestion;
    }
  }

  function stepTypeIcon(stepType?: StepTypeKebabCase) {
    switch (stepType) {
      case 'theory':
        return mdiBook;
      case 'vocabulary':
        return mdiBookAlphabet;
      case 'pairs':
        return mdiNumeric2BoxMultipleOutline;
      case 'single-choice':
        return mdiButtonPointer;
      case 'multi-choice':
        return mdiFormatListGroupPlus;
      case 'fill-in-the-blank':
        return mdiPuzzleEditOutline;
      case 'cross-match':
        return mdiFileArrowUpDownOutline;
      case 'true-false':
        return mdiCheckboxMarkedCircleMinusOutline;
      case 'word-builder':
        return mdiAlphabeticalVariant;
      case 'memory-flip':
        return mdiCardMultipleOutline;
      case 'sentence-builder':
        return mdiTextBoxEditOutline;
      case 'filter':
        return mdiFilterOutline;
      default:
        return mdiLockQuestion;
    }
  }

  return {
    stepCategoryIcon,
    stepTypeIcon,
  };
};
